import { useState, useEffect, useRef } from 'react';
const useConfigChangedState = initial => {
  const initialConfig = initial.get('config');
  const isReportInitialized = useRef(undefined);
  const [configChanged, setConfigChanged] = useState(false);
  useEffect(() => {
    if (isReportInitialized.current) {
      setConfigChanged(true);
    } else {
      isReportInitialized.current = true;
    }
  }, [initialConfig, setConfigChanged]);
  return {
    configChanged,
    setConfigChanged
  };
};
export default useConfigChangedState;